import {Component} from '@angular/core';
import {AuthService} from '../shared/services/auth.service';
import {ActivatedRoute} from '@angular/router';
import {isUUID} from '../shared/utils/utils';
import {GenericApiResponse} from "@webmate-web-core/shared/api/apibase.api";

@Component({
    selector: 'wm-apply-change-email-token',
    styleUrls: ['./apply-change-email-token.component.less'],
    templateUrl: './apply-change-email-token.component.html'
})
export class ApplyChangeEmailTokenComponent {
    state: 'initial' | 'tokenInvalid' | 'awaitingResponse' | 'responseSuccess' | 'responseError' = 'initial';
    error: string | GenericApiResponse = undefined;

    constructor(private authService: AuthService, private route: ActivatedRoute) {}

    ngOnInit() {
        const token = this.route.snapshot.queryParamMap.get('token');
        if (!isUUID(token)) {
            this.state = 'tokenInvalid';
        } else {
            this.applyToken(token);
        }
    }

    private applyToken(token: string) {
        this.state = 'awaitingResponse';
        this.error = undefined;
        this.authService.applyChangeEmailToken(token).subscribe({
            next: () => {
                this.state = 'responseSuccess';
            },
            error: error => {
                this.error = error.error;
                this.state = 'responseError';
            }
        });
    }
}
